document.addEventListener('DOMContentLoaded', function () {
    const closeButton = document.querySelector('.header-block__menu-close');
    const menuTop = document.querySelector('.mobile-menu__top');

    if (closeButton && menuTop) {
        menuTop.appendChild(closeButton);
    }
});
